<template>  
  <!-- View Detail Main Start -->
  <b-modal
    v-model="showModal"
    size="xl"
    scrollable
    title-class="font-18"
    hide-footer
    @hidden="onModalHide"
  >
    <template #modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <h5>
        {{trans.get('__JSON__.Order No')+' '+(order && order.hash_id || '000')}}
        <span class="badge badge-pill badge-soft-primary font-size-12" v-if="order && order.delivery_pickup_types == 'Delivery'">
          {{trans.get('__JSON__.'+order && order.delivery_pickup_types)}}
        </span>
        <span class="badge badge-pill badge-soft-danger font-size-12" v-if="order && order.delivery_pickup_types == 'Takeaway'">
          {{trans.get('__JSON__.'+order && order.delivery_pickup_types)}}
        </span>
        <span class="badge badge-pill badge-soft-danger font-size-12" v-if="order && order.delivery_pickup_types == 'Pickup'">
          {{trans.get('__JSON__.'+order && order.delivery_pickup_types)}}
        </span>
        <span class="badge badge-pill font-size-12" :class="{'badge-soft-success': order && (order.payment_method == 'Cash On Delivery'),'badge-soft-warning':order && (order.payment_method != 'Cash On Delivery')}">
              {{order && (order.payment_method == 'Cash On Delivery'?'COD':order.payment_method.name)}}
        </span>
        <span class="badge badge-pill font-size-12" :class="{'badge-soft-danger':order &&(order.cancelled_by != null )}">
            {{order && (order.cancelled_by != null) ? 'cancel' : ''}}
        </span>
        <span v-if="(order && order.order_status == 'PaymentPending') || (order && order.order_status == 'PaymentFailure')" class="badge badge-pill font-size-12"  :class="{'badge-soft-warning': (order && order.order_status == 'PaymentPending'),'badge-soft-danger':(order && order.order_status == 'PaymentFailure')}">
          {{order && order.order_status == 'PaymentPending' ? 'Pending': 'Failed'}}
        </span>
        <span class="ml-3">{{trans.get('__JSON__.Single Produkte')}}</span><span
                      class="badge badge-success font-size-12 ml-2"
                    >{{singleProductCount}}
                      <!-- {{ (ordersCount && ordersCount.placed_orders) || 0 }} -->
                    </span>
        <span class="ml-3">{{trans.get('__JSON__.Box')}}</span><span
                      class="badge badge-success font-size-12 ml-2"
                    >{{boxCount}}
                      <!-- {{ (ordersCount && ordersCount.placed_orders) || 0 }} -->
                    </span>
        <h6 class="font-color mt-2"><span>{{trans.get('__JSON__.TimeSlot')  }}: {{ startTime }} - {{ endTime }} Uhr</span></h6>
      </h5>
      <div>
      <a v-b-tooltip.hover.v-light :title="trans.get('__JSON__.A4')" :href="config.appurl+'print-order-new/'+base64(order && order.id+','+$auth.getVendorId())" target="_blank"><i class="mdi mdi-printer font-size-15"></i></a>
      <!-- <a v-b-tooltip.hover.v-light :title="trans.get('__JSON__.Thermal Print')" :href="config.appurl+'print-order/'+base64(order && order.id+','+$auth.getVendorId())" target="_blank"><i class="mdi mdi-printer font-size-15"></i></a> -->
      <button @click="close()" class="close">
        <i class="fas fa-times"></i>
      </button>
      </div>
    </template>
    <b-tabs
      justified
      nav-class="nav-tabs-custom mt-0 order-tabs"
      content-class="p-3 text-muted"
    >
    <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-list-ul"></i>
          </span>
          <span class="d-none d-sm-inline-block">{{trans.get('__JSON__.Order Item Details')}}</span>
        </template>
        <!-- <item-order-details :order="order" :loading="orderLoading" :orderStatus="orderStatus"  @readyToCollect="readyToCollect" @actionChanged="$emit('refreshData')" @modalShow="modalShow"/>  -->
        <item-order-details :order="order" :order_id="orderId" :loading="orderLoading" :orderStatus="orderStatus"  @readyToCollect="readyToCollect" @actionChanged="changeAction" @modalShow="modalShow"/> 
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-receipt"></i>
          </span>
          <span class="d-none d-sm-inline-block">{{trans.get('__JSON__.Order Details')}}</span
          >
        </template>
        <order-details :order="order" :loading="orderLoading" :amounts="amounts" /> 
      </b-tab>
      
    </b-tabs>
  </b-modal>
</template>

<script>
import OrderDetails from './order-details'
import ItemOrderDetails from './item-order-detail'
import { orderService } from '../../../services'
import config from '../../../config'
export default {
    components : {OrderDetails, ItemOrderDetails},  
    props :['order-id','orderStatus'],
    data(){
        return {
            config:config,
            orderLoading: false,
            showModal: false,
            order: null,
            amounts: '',
            singleProductCount: 0,
            boxCount: 0,
            startTime: null,
            endTime: null,
        }
    },
    mounted(){
        this.viewDetails()
    },
    methods : {
      viewDetails(){
        this.showModal = true;
        this.orderLoading = true;
        orderService.getOrderAdmin(this.orderId)
          .then(res => {
            this.order = res.data.result;
           
            var startTime = this.order.delivery_from_time.split(':');
            var endTime = this.order.delivery_to_time.split(':');
           
            this.startTime = startTime[0];
            this.endTime = endTime[0];
            this.orderLoading = false;
            var i = 0;
            var j = 0;
            this.order.order_item.map(function(value, key) {
              value.sub_products.map(function(value1, key1) {
                if(value1.product_box_id){
                  i++;
                }
                else{
                  j++;
                }
              });
            });
            this.singleProductCount = j;
            this.boxCount = i;
          })

          this.getOrderAmounts();
      },
      modalShow(value){
        this.showModal = value;
        this.$emit("actionChanged");
      },
      onModalHide(){
        this.showModal = false;
        this.$emit('hidden');
      },

      getOrderAmounts() {
        orderService.getOrderPaidUnpaidAmounts(this.orderId).then(res => {
          this.amounts = res.data.result;
        })
      },

      readyToCollect(value){
        if(value === 1){
          this.showModal = false;
        }
        else
        {
          this.showModal = true;
        }

      },
      changeAction(){
        this.$emit('actionChanged');
      }
    }
}
</script>

<style>
.font-color{
  color:rgb(186, 188, 191);
}
.modal-header .close{
  display : block !important;
}
</style>